export default __webpack_public_path__ + "static/property-area-guide-182140b6bda92bfb414368f505ddba13.png";